const routes = {
  epsList: (): string => 'eps',
  loadEps: (): string => 'eps/show',
  epsRegister: (): string => 'eps',
  epsUpdate: (id: string): string => `eps/${id}`,
};

export default routes;
